export default __webpack_public_path__ + "static/media/SpoqaHanSansNeo-Medium.cf5c6ddc.ttf";